import {
    prop
} from "../../../../common/utils";


function _getWinner(prefix) {
    return state => rank => {
        const rankKey = prefix + (rank === -1 ? 'Last' : rank)
        const {
            _winners
        } = state
        if (_winners) {
            const {winnerMap, userMap} = _winners
            const winner = prop(winnerMap, rankKey, null)
            // console.log([rankKey, winner]);
                // console.log(JSON.stringify(winner));
            if(winner && winner.uid > 0) {
                const user = userMap ? userMap[winner.uid] : null
                winner.logoSrc = user ? user.logoSrc : ''
                winner.rank = rank
                // console.log(JSON.stringify(winner, null, 2));
                return winner
            }
        }
        return null
    }
}

const getPreWinner = _getWinner('pre')
const getFinalWinner = _getWinner('final')

function _getPreRank(type) {
    return state => {
        // console.log(state._preRank);
        return prop(state._preRank, type) || null
    }
}

const preRankScore = _getPreRank(1, 'list', [])
const preRankBuy = _getPreRank(2, 'list', [])
const preRankSell = _getPreRank(3, 'list', [])

function finalRankScore(state) {
    return state._finalRank
}

export default {
    preRankScore,
    preRankBuy,
    preRankSell,
    finalRankScore,
    getPreWinner,
    getFinalWinner
}
